import { Box, Image, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'

export const Statistics = () => {
  const resPadding = usePadding()
  const viewportWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewportWidth)
  return (
    <Box
      flexDirection={isMob ? 'column' : 'row'}
      ph={resPadding}
      align={'center'}
      justify={'center'}
      gap={isMob ? 64 : 80}
      pv={isMob ? 80 : 108}>
      <Box flexDirection={'row'} align={'center'}>
        <Image
          source={require('../../assets/svg/appusers.svg')}
          width={isMob ? 60 : 98}
          height={isMob ? 60 : 98}
          resizeMode={'center'}
        />
        <Spacer direction={'horizontal'} size={isMob ? 16 : 32} />
        <Box flexDirection={'column'}>
          <Text
            title={'Used by over'}
            fontSize={isMob ? 12 : 20}
            letterSpacing={isMob ? -0.24 : -0.4}
            lineHeight={isMob ? 22 : 40}
            color={'BLACK_21'}
            fontFamily={'jiotype-medium'}
          />
          <Text
            title={'2 Million+'}
            fontSize={isMob ? 36 : 64}
            letterSpacing={isMob ? -1.48 : -2.56}
            lineHeight={isMob ? 46 : 60}
            color={'BLACK_21'}
            fontFamily={'jiotype-black'}
          />
          <Box flexDirection={'row'} align={'center'}>
            <Box flexGrow={1} height={1} bg={'DISABLED_GREY'} />
            <Spacer direction={'horizontal'} size={24} />
            <Text
              title={'Users'}
              fontSize={isMob ? 12 : 20}
              letterSpacing={isMob ? -0.24 : -0.4}
              lineHeight={isMob ? 22 : 40}
              color={'BLACK_21'}
              fontFamily={'jiotype-medium'}
            />
          </Box>
        </Box>
      </Box>
      <Box flexDirection={'row'} align={'center'}>
        <Image
          source={require('../../assets/svg/stores.svg')}
          width={isMob ? 60 : 98}
          height={isMob ? 60 : 98}
          resizeMode={'center'}
        />
        <Spacer direction={'horizontal'} size={32} />
        <Box flexDirection={'column'}>
          <Text
            title={'Accepted at stores'}
            fontSize={isMob ? 12 : 20}
            letterSpacing={isMob ? -0.24 : -0.4}
            lineHeight={isMob ? 22 : 40}
            color={'BLACK_21'}
            fontFamily={'jiotype-medium'}
          />
          <Text
            title={'1 Million+'}
            fontSize={isMob ? 36 : 64}
            letterSpacing={isMob ? -1.48 : -2.56}
            lineHeight={isMob ? 46 : 60}
            color={'BLACK_21'}
            fontFamily={'jiotype-black'}
          />
          <Box flexDirection={'row'} align={'center'}>
            <Box flexGrow={1} height={1} bg={'DISABLED_GREY'} />
            <Spacer direction={'horizontal'} size={24} />
            <Text
              title={'Stores'}
              fontSize={isMob ? 12 : 20}
              letterSpacing={isMob ? -0.24 : -0.4}
              lineHeight={isMob ? 22 : 40}
              color={'BLACK_21'}
              fontFamily={'jiotype-medium'}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
